import { Box, Container, useMediaQuery } from "@mui/material";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import React from "react";
import { useTheme } from "@mui/material";
import { useCompany } from "../../context/CompanyContext";
import { usePermissions } from "../../context/PermissionContext";
import NoAccessPage from "../pages/no-access";
const Layout = () => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const theme = useTheme();
    const HEADER_HEIGHT = isMobile ? 16 : 24;
    const { hasNoAccess, isLoadingCompanies } = useCompany();
    const { isForbidden: isNotAppUser } = usePermissions();
    // Show loader while checking companies
    // if (isLoadingCompanies) {
    //   return (
    //     <Box
    //       sx={{
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         height: "100vh",
    //         width: "100%",
    //         backgroundColor: theme.palette.background.default,
    //       }}
    //     >
    //       <WidgetLoader isLoading={true} />
    //     </Box>
    //   );
    // }
    // Case B: signed-in tenant user who is NOT a provisioned app user -> not authorized.
    // Takes precedence: without app membership there are no permissions or companies to show.
    if (isNotAppUser) {
        return React.createElement(NoAccessPage, { reason: "not-authorized" });
    }
    // Case A: provisioned app user but no company/entity access (none assigned or 403).
    if (hasNoAccess && !isLoadingCompanies) {
        return React.createElement(NoAccessPage, { reason: "no-companies" });
    }
    return (React.createElement(Box, { sx: {
            maxWidth: "100vw",
            width: "100%",
            height: "100dvh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: theme.palette.primary.darker,
            overflow: "hidden", // Prevent scroll on background
        } },
        React.createElement(Box, { sx: {
                position: "absolute",
                backgroundImage: "url(/assets/images/bg-vector.svg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                zIndex: 1, // Sit behind everything
                left: "40px",
                top: "-100px",
                width: "700px",
                height: "400px",
                pointerEvents: "none",
            } }),
        React.createElement(Header, null),
        React.createElement(Container, { sx: {
                flexGrow: 1,
                overflowY: "auto",
                backgroundColor: theme.palette.background.default,
                pb: isMobile ? 2 : 0.5,
                borderTopLeftRadius: isMobile ? 32 : 64,
                marginLeft: isTablet ? 1 : 2.5,
                width: isTablet
                    ? `calc(100% - ${theme.spacing(1)})`
                    : `calc(100% - ${theme.spacing(2.5)})`,
                pt: `${HEADER_HEIGHT}px`,
                pl: isMobile ? 1.5 : 3.5,
                pr: isTablet ? 2 : 6,
                position: "relative",
                zIndex: 2,
            }, disableGutters: true, maxWidth: false },
            React.createElement(Outlet, null))));
};
export default Layout;
